import Modal from "@mui/material/Modal";
import {Grid} from "@mui/material";
import {IoClose} from "react-icons/io5";
import {AiOutlineInfoCircle} from "react-icons/ai";
import Button from "@mui/material/Button";
import React from "react";
// import ModalImageSmall from "../../media/site_media/background_images/demo-small.webp";
import ModalImageSmall from "../../media/site_media/illustrations/withme/initial-creator-modal.webp";
import StripeErrorImage from "../../media/site_media/dashboard/StripeError.webp";
import Confetti from "react-confetti";
import {gtag} from "ga-gtag";

export default function ErrorCheckoutModal(props) {
   // Opened with props passed from -> http://localhost:3000/become-a-creator/register
   return(

      <Modal
         open={props.openCheckoutError}
         onClose={() => props.handleCloseCheckoutError()}
         aria-labelledby="modal-modal-title"
         aria-describedby="modal-modal-description"
         disableAutoFocus={true}
         sx={{
            // margin: 'auto',
            backgroundColor: 'rgba(0,0,0,0.47)',
            outline: '0',
            // borderRadius: '5px',
            overflow: 'hidden',
            // minWidth: '50vw',
            display: 'flex',
            zIndex: '1300',
            lineHeight: '25px',
            width:'100%',
            minHeight: '100vh',
            maxHeight: '100vh',
         }}
      >


         <Grid container justifyContent='center' sx={{paddingTop: '20px', paddingBottom: '20px', width:'auto', borderRadius: '5px', margin: 'auto', maxWidth: '650px', outline: 'none'}}>

            {/* <Confetti
               gravity={0.07}
               numberOfPieces={500}
               recycle={false}
               friction={0.99}
               width={props.windowWidth}
               height={props.windowHeight}
            /> */}

            <Grid
               style={{
                  zIndex: '100',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  padding: '30px 30px',
                  boxSizing: 'border-box',
                  width: '100%',
                  outline: '0px',
                  maxWidth: '550px',
                  minWidth: '300px',
                  backgroundColor: 'white',
                  borderRadius: '10px',
                  height: 'auto',
                  minHeight: 'auto',
                  position: 'relative',
                  margin: props.windowWidth < 400 ? '0' : '0 10px',
               }}
            >

               <div style={{position: 'absolute', top: '10px', right: '10px', '&:hover': {cursor: 'pointer'}}}>
                  <a onClick={() => {props.handleCloseCheckoutError()}}>
                     <IoClose className={'modal-close-icon'}/>
                  </a>
               </div>

               <Grid container sx={{justifyContent: "center", alignItems: "center", display: "flex", zIndex: '1000',}}>


                  <div style={{ width: '100%', height: 'auto', borderRadius: '8px',  marginTop: '10px' }}>
                     <img src={StripeErrorImage} style={{ width: '100%', height: 'auto', overflow: 'hidden', borderRadius: '8px', }}/>
                  </div>


                  <div style={{width: '100%', display: 'block', margin: '10px 0px'}}>
                     {/*<h3 style={{fontSize: '28px', margin: '10px auto 0px auto', textAlign: 'center'}}></h3>*/}
                     <h3 style={{margin: '20px auto', textAlign: 'center'}}>Payments temporarily paused for <span style={{textTransform: 'capitalize'}}>{props.influencer_name}</span></h3>

                     <p className={'onboarding_description'} style={{
                        padding: '0px 0px 10px 0px', fontWeight: '500', width: '100%', margin: 'auto', textAlign: 'center', fontsize: '15px', lineHeight: '18px', marginTop: '20px', color: '#6E89AF',
                     }}>
                        This is only a temporary pause. For more information, please <span onClick={() => props.launchHelp()} style={{ textDecoration: 'underline', cursor: 'pointer' }}>reach out to us</span> or you can contact the creator directly.
                     </p>
                  </div>

                  <Button variant="contained" onClick={() => {
                     // window.location.assign('/' + props.influencer_name);
                     props.handleCloseCheckoutError();
                  }} disableElevation
                          sx={{
                             padding: '5px 25px',
                             width: '100%',
                             maxWidth: '400px',
                             textAlign: 'center',
                             display: 'inline-block',
                             margin: '5px auto',
                             borderRadius: '10px',
                             textTransform: 'none',
                             border: '2px var(--brand-color) solid',
                             backgroundColor: 'var(--brand-color)',
                             '&:hover': {
                                backgroundColor: 'var(--brand-color-hover)',
                                border: '2px var(--brand-color-hover) solid',
                             }
                          }}>
                           <span className="fa fa-search"
                                 style={{fontWeight: '600', fontSize: '16px'}}>Understood</span>
                  </Button>
               </Grid>
            </Grid>
         </Grid>
      </Modal>
   )

}


